{{ text || ('component_library.no_description' | translate) }}
